exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/route-handler/route-handler.component.scss
// module id = ../../../../../src/app/core/route-handler/route-handler.component.scss
// module chunks = main